"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataVizAccordion = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var BarChart_1 = require("../dataviz/BarChart");
var PieChart_1 = require("../PieChart");
var Accordion_1 = require("../Accordion");
var DataVizAccordion = function (_a) {
    var title = _a.title, _b = _a.chartOptions, chartOptions = _b === void 0 ? [] : _b, props = __rest(_a, ["title", "chartOptions"]);
    var ChartComps = {
        PieChart: {
            comp: PieChart_1.PieChart,
            wrapperStyle: {}
        },
        BarChart: {
            comp: BarChart_1.BarChart,
            wrapperStyle: { padding: "0 1rem 0.6rem 1rem" }
        },
    };
    var _c = (0, react_2.useState)(chartOptions[0]), activeCompConfig = _c[0], setActiveCompConfig = _c[1];
    var genActiveChartComp = function (activeCompConfig) {
        var ActiveChartComp = ChartComps[activeCompConfig.comp].comp;
        var wrapperStyle = ChartComps[activeCompConfig.comp].wrapperStyle;
        return (react_1.default.createElement("div", { style: __assign({ padding: "0 1.6rem 1rem 1.6rem" }, (wrapperStyle || {})) },
            react_1.default.createElement(ActiveChartComp, __assign({}, props, activeCompConfig.props))));
    };
    return (react_1.default.createElement(Accordion_1.Accordion, { key: JSON.stringify(activeCompConfig), title: title, actionsConfig: chartOptions.length > 1 && chartOptions.map(function (d) { return ({
            display: d.display,
            onClick: function () {
                return setActiveCompConfig(d);
            },
        }); }) }, genActiveChartComp(activeCompConfig)));
};
exports.DataVizAccordion = DataVizAccordion;
